import { fallbackString } from "@shared/utils";
import { resolveS3FileInfo } from "../../../document";
import { DocumentFileRow } from "../document-file-row";
import "./representation-document-number-cell.scss";

type AttachmentFileLike = {
  file?: {
    fileId?: string | null;
    id?: string | null;
    fileName?: string | null;
  } | null;
};

type RepresentationDocumentNumberCellProps = {
  number?: string | null;
  attachment?: AttachmentFileLike | null;
};

export function RepresentationDocumentNumberCell({
  number,
  attachment,
}: RepresentationDocumentNumberCellProps) {
  const resolved = resolveS3FileInfo(attachment?.file);

  if (!resolved) {
    return (
      <span className="representation-document-number-cell">
        {fallbackString(number)}
      </span>
    );
  }

  return (
    <span
      className="representation-document-number-cell"
      onClick={(event) => event.stopPropagation()}
    >
      <DocumentFileRow
        inline
        variant="plain"
        downloadIconPosition="right"
        fileName={String(fallbackString(number) || resolved.fileName)}
        fileId={resolved.fileId}
      />
    </span>
  );
}
